export const GENDER_ITEMS = {
    FEMALE: "Female",
    MALE: "Male",
    OTHER: "Other",
    UNKNOWN: "Unknown"
};